export default "__VITE_ASSET__66c1556e__"